import { render, staticRenderFns } from "./mainSwitch.vue?vue&type=template&id=a3853914&scoped=true"
import script from "./mainSwitch.vue?vue&type=script&lang=js"
export * from "./mainSwitch.vue?vue&type=script&lang=js"
import style0 from "./mainSwitch.vue?vue&type=style&index=0&id=a3853914&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3853914",
  null
  
)

export default component.exports